module.exports = __webpack_public_path__ + "static/media/waves.baeb3a5f.png";